
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Store } from 'lucide-react';

interface ShopBadgeProps {
  shopName?: string;
  shopId?: string;
  organizationId?: string | null;
}

const ShopBadge = ({ shopName, shopId, organizationId }: ShopBadgeProps) => {
  if (!shopId && !organizationId) return null;
  
  return (
    <div className="flex items-center gap-2 mb-4">
      {shopId && (
        <Badge variant="outline" className="flex items-center gap-1 px-2 py-1">
          <Store className="h-3 w-3" />
          <span className="text-xs font-medium">
            {shopName || `Boutique: ${shopId}`}
          </span>
        </Badge>
      )}
      
      {organizationId && (
        <Badge variant="outline" className="flex items-center gap-1 px-2 py-1 bg-slate-50">
          <span className="text-xs font-medium">
            Org: {organizationId.substring(0, 8)}...
          </span>
        </Badge>
      )}
    </div>
  );
};

export default ShopBadge;
